{
    const link = document.getElementById('product-table-size-link');

    if(link) {
        link.addEventListener('click', function() {
            const device = window.screen.width < 576 ? 'mob' : 'comp';
        
            let imgPath = productTableSize.file + productTableSize.parent;
            
            imgPath+= '-' + device;
            imgPath+= '-' + lang;
            imgPath+= '.jpg';
        
            console.log(imgPath);
        
            document.getElementById('table-size-img').setAttribute('src', imgPath);        
        });    
    }
}
